import { useLastUpdatedTime } from './useLastUpdatedTime';
import { ICheckpointQueue } from '../../domain/models/ICheckpointQueue';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';

export function useFormattedLastUpdatedTime(
	checkpointQueues: ICheckpointQueue[] | undefined,
) {
	const { t } = useTranslation();
	const lastUpdatedTime = useLastUpdatedTime(checkpointQueues);

	return !lastUpdatedTime
		? t('security_checkpoint_last_updated_placeholder')
		: lastUpdatedTime.format('LT');
}
